import { FlexBox, JoonUIColor, SPACING, Typography } from "@joonapp/web-shared"
import dayjs from "dayjs"
import { useTranslation } from "react-i18next"

export const PaywallBundlingFreeTrial = () => {
  const { t } = useTranslation()
  const dateIn7days = dayjs().add(7, "day").format("MMMM D")

  return (
    <FlexBox
      direction="column"
      gap={SPACING.space2}
      style={{
        borderTop: `1px solid ${JoonUIColor.border.default}`,
        paddingTop: SPACING.space3,
      }}
    >
      <Typography variant="bodyBold" textAlign="left">
        {t("PAYWALL_TRIAL_HOW_IT_WORKS")}
      </Typography>
      <FlexBox
        direction="row"
        justify="center"
        gap={SPACING.space4}
        wrap={false}
      >
        <div style={{ position: "relative" }}>
          <FlexBox
            direction="column"
            align="center"
            wrap={false}
            gap={SPACING.space6}
            style={{
              width: "30px",
              borderRadius: "20px",
              background: JoonUIColor.background.accent,
              position: "relative",
              color: "white",
              fontSize: "24px",
              zIndex: 5,
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                padding: "10px 0px",
                height: "40px",
              }}
            >
              <img
                src="/images/icons/unlock.svg"
                className="paywall-icon"
                alt="bell"
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                padding: "10px 0px",
                height: "40px",
              }}
            >
              <img
                src="/images/icons/bell.svg"
                className="paywall-icon"
                alt="bell"
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                padding: "10px 0px",
                height: "40px",
              }}
            >
              <img
                src="/images/icons/star.svg"
                className="paywall-icon"
                alt="bell"
              />
            </div>
          </FlexBox>
          <div
            style={{
              width: "30px",
              height: "120px",
              zIndex: 2,
              position: "relative",
              borderRadius: "20px",
              marginTop: "-30px",
              background:
                "linear-gradient(180deg, rgba(103, 113, 247, 0.7) 20%, rgba(103, 94, 239, 0.19) 95%, rgba(86, 97, 225, 0) 100%)",
            }}
          />
        </div>
        <FlexBox
          direction="column"
          align="center"
          wrap={false}
          gap={SPACING.space6}
          style={{ paddingTop: SPACING.space2 }}
        >
          <FlexBox direction="column" style={{ height: "40px" }} wrap={false}>
            <Typography
              variant="bodySmallBold"
              color={JoonUIColor.text.primaryAccent}
            >
              {t("PAYWALL_TRIAL_TODAY")}
            </Typography>
            <Typography variant="bodyXSmallBold">
              {t("PAYWALL_TRIAL_TODAY_DESC")}
            </Typography>
          </FlexBox>
          <FlexBox direction="column" style={{ height: "40px" }} wrap={false}>
            <Typography
              variant="bodySmallBold"
              color={JoonUIColor.text.primaryAccent}
            >
              {t("PAYWALL_TRIAL_DAY5")}
            </Typography>
            <Typography variant="bodyXSmallBold">
              {t("PAYWALL_TRIAL_DAY5_DESC")}
            </Typography>
          </FlexBox>
          <FlexBox direction="column" style={{ height: "40px" }} wrap={false}>
            <Typography
              variant="bodySmallBold"
              color={JoonUIColor.text.primaryAccent}
            >
              {t("PAYWALL_TRIAL_DAY7")}
            </Typography>
            <Typography variant="bodyXSmallBold">
              {t("PAYWALL_TRIAL_DAY7_DESC", { date: dateIn7days })}
            </Typography>
          </FlexBox>
        </FlexBox>
      </FlexBox>
    </FlexBox>
  )
}
